import {
	// New fields
	INPUT_CONTACT_SCHOOL_NAME,
	INPUT_CONTACT_CLASS_NAME,
	INPUT_CONTACT_COMMITTEE_PRESIDENT,
	INPUT_CONTACT_COMMITTEE_PHONE,
	INPUT_CONTACT_COMMITTEE_EMAIL,
	INPUT_CONTACT_CLASS_PRESIDENT,
	INPUT_CONTACT_CLASS_PHONE,
	INPUT_CONTACT_CLASS_EMAIL,
	INPUT_CONTACT_DATE_PROM,
	INPUT_CONTACT_GUESTS_NUM,
	// New regular fields
	INPUT_CONTACT_PHONE,
	INPUT_CONTACT_DATE_EVENT,
	INPUT_CONTACT_TYPE_EVENT,
	// Original fields
	INPUT_CONTACT_NAME,
	INPUT_CONTACT_EMAIL,
	INPUT_CONTACT_MSG,
	SEND_CONTACT,
	GET_CONTACT_DB,
	SET_CONTACT_STATUS
} from './Types';

// New fields
export const inputSchoolName = txt => { return { type: INPUT_CONTACT_SCHOOL_NAME, payload: txt } };
export const inputClassName = txt => { return { type: INPUT_CONTACT_CLASS_NAME, payload: txt } };
export const inputCommitteePresident = txt => { return { type: INPUT_CONTACT_COMMITTEE_PRESIDENT, payload: txt } };
export const inputCommitteePhone = txt => { return { type: INPUT_CONTACT_COMMITTEE_PHONE, payload: txt } };
export const inputCommitteeEmail = txt => { return { type: INPUT_CONTACT_COMMITTEE_EMAIL, payload: txt } };
export const inputClassPresident = txt => { return { type: INPUT_CONTACT_CLASS_PRESIDENT, payload: txt } };
export const inputClassPhone = txt => { return { type: INPUT_CONTACT_CLASS_PHONE, payload: txt } };
export const inputClassEmail = txt => { return { type: INPUT_CONTACT_CLASS_EMAIL, payload: txt } };
export const inputDateProm = txt => { return { type: INPUT_CONTACT_DATE_PROM, payload: txt } };
export const inputGuestsNumber = txt => { return { type: INPUT_CONTACT_GUESTS_NUM, payload: txt } };
// New regular fields
export const inputPhone = txt => { return { type: INPUT_CONTACT_PHONE, payload: txt } };
export const inputDateEvent = txt => { return { type: INPUT_CONTACT_DATE_EVENT, payload: txt } };
export const inputTypeEvent = txt => { return { type: INPUT_CONTACT_TYPE_EVENT, payload: txt } };
// Original fields
export const inputName = txt => { return { type: INPUT_CONTACT_NAME, payload: txt } };
export const inputEmail = txt => { return { type: INPUT_CONTACT_EMAIL, payload: txt } };
export const inputMsg = txt => { return { type: INPUT_CONTACT_MSG, payload: txt } };
export const sendContact = () => { return { type: SEND_CONTACT } };
export const getContactDB = () => { return { type: GET_CONTACT_DB } };
export const setContactStatus = txt => { return { type: SET_CONTACT_STATUS, payload: txt } };


// WEBPACK FOOTER //
// ./src/actions/ContactActions.js